<template>
  <el-dialog
      title="抵扣金额明细"
      width="50%"
      class="viewDeductMoney"
      :visible="isShowDeductMoney"
      :show-close="false"
  >
    <el-table :data="tableData" max-height="450" border style="width: 100%" size="small">
      <el-table-column
          show-overflow-tooltip
          fixed
          prop="deductionType"
          label="抵扣类型"
      >
      </el-table-column>
      <el-table-column
          show-overflow-tooltip
          prop="deductionMoney"
          label="抵扣金额"
      >
      </el-table-column>
    </el-table>

    <div slot="footer" class="dialog-footer">
      <el-button @click="hideDialog('reconcileBill/mu_isShowDeductMoney')">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {mapState} from "vuex";
import { dialogCtrl } from "@/mixins";

export default {
  name: "viewDeductMoney",
  components: {},
  props: ["orderId"],
  mixins: [
    dialogCtrl,
  ],
  data() {
    return {
      tableData: []
    }
  },
  computed: {
    ...mapState('reconcileBill', [
      "isShowDeductMoney",
    ]),
  },
  methods: {
    async init() {
      this.getTableData()
      this.$debugVue('v_viewDeductMoney', this)
    },
    async getTableData() {
      const params = {
        orderId: this.orderId
      }
      const res = await this.fetch.get('reconcileBill_getDeductRecord',{ params })
      this.tableData = res.data || []
    }
  },
  mounted() {
    this.init()
  }
};
</script>

<style scoped lang="scss">

</style>
